import vehicle from './vehicle';

const root = {
	vehicle
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js